import { z } from 'zod';
// Define Zod Schema for validation
export const MaintenanceSchema = z.object({
  workOrderNumber: z.string().default('-'),
  orderType: z.string().default('-'),
  actualWorkDescription: z.string().default('-'),
  equipmentNumber: z.string().default('-'),
  componentName: z.string().default('-'),
  maintenanceActivityType: z.string().default('-'),
  actualStartDate: z.string(),
  actualEndDate: z.string(),
  laborHours: z.string().default('-'),
  personResponsible: z.string().default('-'),
  priority: z.string().default('-'),
  plantNumber: z.string().default('-'),
  comments: z.string().max(200, 'Comments cannot exceed 200 characters').optional(),
});
